import { isDefined } from "@omni/utils/helper.utils";
import { KeyboardEvent as SyntheticKeyboardEvent } from "react";

import { KeyNames } from "@/utils/enums";

type KeyHandler<TKeyboardEvent extends KeyboardEvent | SyntheticKeyboardEvent> =
    {
        keys?: Array<KeyNames>;
        defaultExcept?: Array<KeyNames>;
        isPressed?: (key: string, event: TKeyboardEvent) => boolean;
        handler: (event: TKeyboardEvent) => void;
    };

type CreateKeyHandler = <
    TKeyboardEvent extends KeyboardEvent | SyntheticKeyboardEvent
>(
    keyHandlers: Array<KeyHandler<TKeyboardEvent>>
) => (event: TKeyboardEvent) => void;
const createKeyHandler: CreateKeyHandler = (keyHandlers) => (event) => {
    const pressedKey = event.key;
    const isPressed = (key: KeyNames) => key === pressedKey;

    const keyHandler =
        keyHandlers.find((keyHandler) =>
            isDefined(keyHandler.keys?.find(isPressed))
        ) ??
        keyHandlers.find(
            (keyHandler) =>
                isDefined(keyHandler.isPressed) &&
                keyHandler.isPressed(pressedKey, event)
        ) ??
        keyHandlers.find(
            (keyHandler) =>
                isDefined(keyHandler.defaultExcept) &&
                !isDefined(keyHandler.defaultExcept.find(isPressed))
        );

    keyHandler?.handler?.(event);
};

export { createKeyHandler };
